import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function GrainIcon(props: IconProps) {
    return <Icon {...props} iconKey={"grain"}/>
}
